/**
 * CoachFabGate — the one place the 2.0 room retires the floating "Ask a coach" button (P9).
 *
 * With `chat_2_0_v1` on, `CoachFab` and its first-run tip ("Your coaches live here") are RETIRED for athlete, dual
 * and guardian accounts: the door is the top-bar "Ask a coach" pill (`AskCoachPill`) and the desktop side-nav item,
 * and both open the room. This wrapper mounts nothing for them, so none of the button's listeners (scroll, resize,
 * visibility) run either.
 *
 * A COACH-ONLY account keeps today's button whatever the flag says. The pill is never drawn for it (P9.1) and the
 * room is not its screen (`/chat` is the coach boundary), but the button is the one persistent phone door to that
 * boundary: the coach rail and tab bar carry no chat item (B76B), and no coach surface (Team, Meets, Settings,
 * approvals) links to `/chat`. Retiring it would leave a coach-only account with no way in. The role is read with
 * the coach-boundary answer (`useAccountRole().coachOnly`) and held while it is pending, so an athlete never sees
 * the button flash while the role loads.
 *
 * Flag off: it renders `<CoachFab />` and nothing else, reads no role hook, so the button, its tip and its tests are
 * exactly as they were. `CoachFab.tsx` is not edited.
 *
 * The flag is read with the cached hint (`useRoomEntryFlag`): a returning flag-on device holds the button back from
 * the first frame instead of drawing it and then removing it; the first-ever load waits for `/api/config`.
 */
import { useAccountRole } from '../../hooks/useAccountRole';
import { CoachFab } from './CoachFab';
import { useRoomEntryFlag } from './useRoomEntryFlag';

export function CoachFabGate(): JSX.Element | null {
  const roomOn = useRoomEntryFlag();
  return roomOn ? <CoachOnlyFab /> : <CoachFab />;
}

/** Flag on: the button survives for a coach-only account and for nobody else. */
function CoachOnlyFab(): JSX.Element | null {
  const { coachOnly, boundaryPending } = useAccountRole();
  return coachOnly && !boundaryPending ? <CoachFab /> : null;
}
